import MediaKit from '@/interfaces/mediakit.interface'
import onEnvironmentChange from '@/observables/environment.observable'
import Environment from '@interfaces/environment.interface'
import LogService from '@services/log/log.service'
import MainService from '@services/main/main.service'
import { AxiosResponse } from 'axios'
import { take } from 'rxjs/operators'

export default class HeimdallService extends MainService {
  url: string
  logService = new LogService()

  constructor(heimdallUrl?: string) {
    super()
    if (!heimdallUrl) {
      onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidApis?.heimdall
      })
    } else {
      this.url = heimdallUrl
    }
    this.logService.init('Heimdall Service')
  }

  async getMediaKitSelf(idProfile?: string) {
    const headers = await this.getHeaders()
    return this.http
      .get(`${this.url}/mediakit/self?idProfile=${idProfile}`, { headers })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Can not get influencers media kit',
          error,
        })
        return error.response
      })
  }

  async getAllMediaKit(formatChart?: string) {
    const headers = await this.getHeaders()
    const params = formatChart ? `?formatChart=${formatChart}` : ''

    return this.http
      .get(`${this.url}/mediakit/all/self${params}`, {
        headers,
      })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Can not get influencers media kit',
          error,
        })
        return error.response
      })
  }

  async patchMediaKit(mediaKit: MediaKit) {
    mediaKit = new MediaKit(mediaKit)
    const headers = await this.getHeaders()
    return this.http
      .patch(`${this.url}/mediakit/self`, mediaKit.toPatchPayload(), {
        headers,
      })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Can not get update media kit',
          error,
        })
        return error.response
      })
  }
}
